import React from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";

import redBag from "../images/redbag.svg";

import "../styles/css/Home.css";
import Background from "../component/Background";
import BurgerNav from "../component/BurgerNav";
const style = {
//   background: "#2C2626",
  color: "white",
};

function Home() {
   
  return (
      <div className="page" style={style}>
          
          <NavBar />
          {/* <BurgerNav/> */}
      <main className="content flex-container main">
        <div className="Home-sentence">
          <p>Looking for the right product for you? Stop, It’s right here.</p>
              </div>
              {/* <div className="red-image-div to-right flex-container">
                  <img className="red-bag to-right" src={redBag}/>
              </div> */}
      </main>
          <Footer className="home-footer" />
          <Background/>
    </div>
  );
}

export default Home;
